import React from 'react';
import classNames from 'classnames';

import { mixPanelEvents } from 'constants/mixPanel';
import { ATTENDANCE_URL } from 'constants/endpoints';

import * as mixpanel from 'services/mixPanel';

type LoggingStatusCardProps = {
  totalDuration: string | number;
  selfPending: number;
  selfMissing: number | number[];
};

export default function LoggingStatusCard({ totalDuration, selfPending, selfMissing }: LoggingStatusCardProps) {
  const { self } = mixPanelEvents.view;

  const isPendingZero = selfPending === 0;
  const isMissingZero = Array.isArray(selfMissing);

  return (
    <div className="full-scope-card dashboard__card work-status d-flex flex-direction-column">
      <div className="logging-status actions">
        <div className="logging-status__item">
          <div className="logging-status__count">{totalDuration}</div>
          <div className="logging-status__label">Logged this week</div>
        </div>

        <a
          className="logging-status__item"
          href={ATTENDANCE_URL}
          target="_blank"
          onClick={() => {
            mixpanel.trackEvent(self.worklogPending);
          }}
          rel="noreferrer"
        >
          <div
            className={classNames('logging-status__count', {
              'logging-status__count--empty': isPendingZero,
              'logging-status__count--pending': !isPendingZero,
            })}
          >
            {selfPending}
          </div>
          <div className="logging-status__label">Worklog pending</div>
        </a>

        <a
          className="logging-status__item"
          href={ATTENDANCE_URL}
          target="_blank"
          onClick={() => {
            mixpanel.trackEvent(self.attendanceMissed);
          }}
          rel="noreferrer"
        >
          <div
            className={classNames('logging-status__count', {
              'logging-status__count--empty': isMissingZero,
              'logging-status__count--missed': !isMissingZero,
            })}
          >
            {isMissingZero ? 0 : selfMissing}
          </div>
          <div className="logging-status__label">Attendance missed</div>
        </a>
      </div>
    </div>
  );
}
